module.exports = __webpack_public_path__ + "img/TeacherDavidL.0efaf4f9.png";